import { Button } from "@sellar-io/components";
import { useNavigate } from "react-router";
import { ACCOUNT_NOTIFICATION_SETTINGS } from "../../constants/routes";
import { Alert } from "../alert/Alert";
import { Dialog, DialogNavigation, DialogContent } from "../modal/Dialog";

export const PushNotificationSettingsDialog = ({
  active,
  onDismiss,
}: {
  active: boolean;
  onDismiss: () => void;
}) => {
  const navigate = useNavigate();
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        className={"relative z-10 pb-0"}
        title="Push notifications enabled"
      />
      <DialogContent className={"py-6"}>
        <Alert
          className="mb-4 w-full font-bold"
          type="success"
          message="Push notifications enabled"
        />
        <p className="text-center">
          {
            "Thank you for enabling push notifications from Sellar. You can review or change which push notifications you wish to receive any time by going to Settings → Your Account → Notifications."
          }
        </p>
        <div className="mt-8 flex justify-end">
          <Button
            onClick={() => {
              onDismiss();
              navigate(ACCOUNT_NOTIFICATION_SETTINGS);
            }}
          >
            Go to settings
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
